import StorageService from '@/services/storage.service'
import storageKeys from '@/constans/storageKeys'
import { defaultFilters } from '@/models/GradeHistory/helpers'
import GradeHistoryRepository from '@/repository/admin/gradeHistoryRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'

const state = {
  gradeHistoryList: [],
  isLoading: false,
  lastRecount: null,
  isFetchingError: false,
  filters: StorageService.get(storageKeys.GRADE_HISTORY_FILTERS) || { ...defaultFilters },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  gradeHistoryList: state => state.gradeHistoryList,
  isLoading: state => state.isLoading,
  lastRecount: state => state.lastRecount,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadGradeHistoryList(context, filters) {
    context.commit('setFilters', filters)
    context.commit('setIsLoading', true)

    StorageService.set(storageKeys.GRADE_HISTORY_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })
    const { data } = await GradeHistoryRepository.list(preparedFilters)

    context.commit('setGradeHistory', { data, filters })
    context.commit('setIsLoading', false)

    return { gradeHistoryList: data.items, pagination: data.pagination, lastRecount: data.date }
  },
  async recountOperatorGrades() {
    await GradeHistoryRepository.recountGrades()
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.GRADE_HISTORY_FILTERS)
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.GRADE_HISTORY_FILTERS, updatedFilters)
  },
}

const mutations = {
  setGradeHistory(state, { data, filters }) {
    state.gradeHistoryList = [...data.items]
    state.lastRecount = data.date
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setIsFetchingError(state, isFetchingError) {
    state.isFetchingError = isFetchingError
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
